import React from 'react'
import styled, { css } from 'styled-components'
import { Box } from 'components'

interface IHandle {
  vertical: boolean
  onMouseDown: (e: React.MouseEvent<HTMLDivElement>) => void
  onTouchStart: (e: React.TouchEvent<HTMLDivElement>) => void
}

interface IHandleContentWrapper {
  vertical: boolean
}

export const SliderHandle = styled.div<IHandle>`
  ${({ vertical }) => css`
    user-select: none;
    touch-action: none;
    position: relative;
    z-index: 100;
    cursor: pointer;
    ${!vertical &&
      css`
        width: 0;
        display: flex;
        height: 100%;
      `}
    ${vertical &&
      css`
        height: 0;
      `}
  `}
`

export const HandleContentWrapper = styled(Box)<IHandleContentWrapper>`
  /* Applies height of child */
  display: inline-flex;
  /* Position content centered to SliderHandle */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -47%);
  ${({ vertical }) => css`
    ${!vertical &&
      css`
        transform: translate(-47%, -50%);
      `}
  `}
`
